module.exports = __webpack_public_path__ + "static/attachment02-e3974f719137aa4cbfedb0945ed5ee44.jpg";